import * as React from 'react';

import {ChartTooltip} from 'shells/charts/chart-tooltip';

type PayloadValues = {
    bucket: string;
    count: number;
};
type PayloadType = {
    active: boolean;
    payload: {
        payload: PayloadValues[];
    };
};

type Props = {
    payload: PayloadType;
};

export const CompetitorsDonutChartTooltip = (props: Props) => {
    // @ts-expect-error
    const payload = props.payload.active ? props.payload.payload[0] : undefined;

    if (payload) {
        const {bucket, count, percent, fill} = payload.payload;

        return (
            <ChartTooltip
                header={{text: bucket, dotColor: fill}}
                rows={[
                    {
                        label: 'Visitors',
                        value: count.toLocaleString(),
                    },
                    {
                        label: 'Market share',
                        value:
                            // This matches the format of the percentage in the table
                            percent < 0.01 ? (percent * 100).toFixed(2) : Math.round(percent * 100),
                        isPercentage: true,
                    },
                ]}
            />
        );
    }

    return <></>;
};
